import name from './name'

const selectSliceData = state => state[name]

const selectMessages = state => selectSliceData(state).messages

export {
  selectMessages
}
